import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.css';
import {BrowserRouter as Router, Route, Routes} from "react-router-dom";
import Curriculum from "./components/Curriculum";
import Blog from "./components/Blog";
import Social from "./components/Social";
import Logme from "./components/Logme";
import LogOut from "./components/admin/Logout";
import CurriculumsAdmin from "./components/admin/Curriculums";
import CurriculumAdmin from "./components/admin/Curriculum";
import CareersAdmin from "./components/admin/Careers";
import CareerAdmin from "./components/admin/Career";
import CareerAdminAdd from "./components/admin/AddCareer";
import BlogsAdmin from "./components/admin/Blogs";
import EducationAdmin from "./components/admin/Education";
import Linktree from "./components/Linktree";
import Stats from "./components/admin/Stats";

import Test from "./components/Test";
import ClickInfos from "./components/admin/ClickInfos";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
      <Router>
          <Routes>
              <Route Key="Curriculum" path='/curriculum' element={<Curriculum />} />
              <Route Key="Home" path='/' element={<Blog />} />
              <Route Key="Blog" path='/blog' element={<Blog />} />
              <Route Key="BlogsAdmin" path='/admin/blogs' element={<BlogsAdmin />} />
              <Route Key="CurriculumAdmin" path='/admin/curriculums' element={<CurriculumsAdmin />} />
              <Route Key="CurriculumAdminid" path='/admin/curriculum/:id' element={<CurriculumAdmin />} />
              <Route Key="CareersAdmin" path='/admin/careers' element={<CareersAdmin />} />
              <Route Key="CareerAdminid" path='/admin/career/:id' element={<CareerAdmin />} />
              <Route Key="CareerAdminadd" path='/admin/career/add' element={<CareerAdminAdd />} />
              <Route Key="EducationAdmin" path='/admin/education' element={<EducationAdmin />} />
              <Route key="StatsAdmin" path='/admin/stats' element={<Stats/>} />

              <Route Key="LogOut" path='/admin/logout' element={<LogOut />} />
              <Route Key="Logme" path='/logme' element={<Logme />} />
              <Route Key="Social" path='/social' element={<Social />} />
              <Route Key="Linktree" path='/linktree' element={<Linktree />} />
              <Route Key="ClickInfos" path='/admin/clickinfos' element={<ClickInfos />} />
              <Route Key="Social" path='/test' element={<Test />} />

          </Routes>
      </Router>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
